<mat-card role="region" [attr.aria-labelledby]="'my-time-off-requests-title'">
    <mat-card-title>
        <h2 id="my-time-off-requests-title" appLocalizationPopupDirective [localizationCode]="'MyTimeOffRequests'">{{ 'MyTimeOffRequests' | translate: {Default: "My Time Off Requests"} }}</h2>

        <div role="group" [attr.aria-label]="'Filter' | translate: {Default: 'Filter'}">
            <mat-form-field appearance="outline" appLocalizationPopupDirective [localizationCode]="'Status'">
                <mat-label>{{ 'Status' | translate: {Default: "Status"} }}</mat-label>
                <mat-select
                    (selectionChange)="getLeaveRequests()"
                    [(ngModel)]="selectedStatusFilters"
                    multiple
                    [attr.aria-label]="'Status' | translate: {Default: 'Status'}"
                >
                    <mat-select-trigger>
                        {{ getSelectedStatusesText() }}
                    </mat-select-trigger>
                  <mat-option *ngFor="let option of statusOptions" appLocalizationPopupDirective [localizationCode]="option.name" [value]="option">{{option.name | translate}}</mat-option>
                </mat-select>
            </mat-form-field>
    
            <mat-form-field appLocalizationPopupDirective [localizationCode]="'Filter'" appearance="outline">
                <mat-label>{{ 'Filter' | translate: {Default: "Filter"} }}</mat-label>
                <mat-select
                    (selectionChange)="getLeaveRequests()"
                    [(ngModel)]="selectedFilter"
                    [attr.aria-label]="'Filter' | translate: {Default: 'Filter'}"
                >
                    <mat-select-trigger>
                        {{ selectedFilter.text | translate}}
                    </mat-select-trigger>
                    <mat-option *ngFor="let option of filterOptions" [value]="option">
                        <div appLocalizationPopupDirective [localizationCode]="option.text">{{ option.text | translate}}</div>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </mat-card-title>
  
    <mat-card-content>
        <div class="time-off-types-container" *ngIf="leaveRequests$ | withLoading | async as leaveRequests" [attr.aria-busy]="leaveRequests.loading ? 'true' : 'false'">
            <ng-template [ngIf]="leaveRequests.value">
                <div class="no-data" *ngIf="leaveRequests.value?.data?.length === 0" appLocalizationPopupDirective [localizationCode]="'NoTimeOffRequests'" role="status" aria-live="polite">
                    <mat-icon aria-hidden="true" class="material-icons-outlined">date_range</mat-icon>

                    {{ 'NoTimeOffRequests' | translate: {Default: "No Time Off Requests"} }}
                </div>

                <mat-list>
                    <ng-container *ngFor="let leaveRequest of leaveRequests.value?.data">
                        <app-requests-list-item 
                            [leaveRequest]="leaveRequest"
                            (openLeaveRequestDialog)="openLeaveRequestDialog($event)"
                            (refreshRequests)="getLeaveRequests()"
                        ></app-requests-list-item>
                    </ng-container>
                </mat-list>
            </ng-template>
            <ng-template [ngIf]="leaveRequests.error">
                <div role="alert" aria-live="assertive">Error {{ leaveRequests.error }}</div>
            </ng-template>
            <ng-template [ngIf]="leaveRequests.loading">
                <ngx-skeleton-loader
                    count="5"
                    role="status"
                    aria-live="polite"
                    [attr.aria-label]="'Loading' | translate: {Default: 'Loading'}"
                    [theme]="{ 
                        'height.px': 50
                    }"
                ></ngx-skeleton-loader>
            </ng-template>
        </div>
    </mat-card-content>
</mat-card>